import { ToolbarProps } from 'react-admin';

import { StyledToolbar } from './Toolbar.styled';

type Props = Omit<ToolbarProps, 'sx'>;

export const Toolbar: React.FC<Props> = ({ children, ...restProps }) => {
  return <StyledToolbar {...restProps}>{children}</StyledToolbar>;
};
